import { render, staticRenderFns } from "./HeadingWave.vue?vue&type=template&id=00acf622&scoped=true"
import script from "./HeadingWave.vue?vue&type=script&lang=ts"
export * from "./HeadingWave.vue?vue&type=script&lang=ts"
import style0 from "./HeadingWave.vue?vue&type=style&index=0&id=00acf622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00acf622",
  null
  
)

export default component.exports